export default __webpack_public_path__ + "static/media/gallery-wip-handle-cover_01.8735f8c9.jpg";